import { render, staticRenderFns } from "./check-your-vitals.vue?vue&type=template&id=35ed30b1&"
import script from "./check-your-vitals.vue?vue&type=script&lang=js&"
export * from "./check-your-vitals.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports